// import { focusRing } from '../../../Themes/base/focusRing';
import { StyleObject } from '../../../Themes';

export const linkContainer = { display: 'flex' };

export const linkBaseStyle = (props: any) => {
	return {
		fontFamily: props.bold ? 'var(--epods--font-base-semibold)' : 'var(--epods--font-base)',
		textDecoration: props.removeUnderline ? 'none' : 'inherit',
		fontSize: 'var(--epods--font-size-p)',
		lineSize: 'var(--epods--line-height-h3)',
		color: 'var(--epods--color-text-primary-action)',
		':hover': {
			lineSize: 'var(--epods--line-height-breadcrumbs)',
			cursor: 'pointer',
			color: 'var(--epods--color-background-btn-primary-active)',
			textDecoration: 'underline',
		},
		':visited': {
			color: 'var(--epods--color-text-primary-action)',
			':hover': {
				cursor: 'var(--epods--property-pointer)',
				color: 'var(--epods--color-background-btn-primary-active)',
				textDecoration: 'underline',
			},
		},
		// ':focus': focusRing,
	} as StyleObject;
};

export const linkBaseStyleDisabled = {
	fontFamily: 'var(--epods--font-base)',
	fontSize: 'var(--epods--font-size-p)',
	lineSize: 'var(--epods--line-height-h3)',
	color: 'var(--epods--color-btn-primary-disabled)',
	pointerEvents: 'none',
	':hover': {
		lineSize: 'var(--epods--line-height-breadcrumbs)',
		cursor: 'default',
		color: 'var(--epods--color-btn-primary-disabled)',
		textDecoration: 'underline',
	},
	':visited': {
		color: 'var(--epods--color-text-primary-action)',
		':hover': {
			cursor: 'default',
			color: 'var(--epods--color-btn-primary-disabled)',
			textDecoration: 'underline',
		},
	},
} as StyleObject;

export const linkSideBarStyle = {
	paddingTop: 'var(--epods--space-inset-s)',
	paddingBottom: 'var(--epods--space-inset-s)',
	fontFamily: 'var(--epods--font-base-semibold)',
	fontSize: 'var(--epods--font-size-p)',
	lineSize: 'var(--epods--line-height-h3)',
	color: 'var(--epods--color-black)',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	textDecoration: 'none',
	':hover': {
		lineSize: 'var(--epods--line-height-breadcrumbs)',
		cursor: 'pointer',
		color: 'var(--epods--color-black)',
		textDecoration: 'none',
	},
	':visited': {
		color: 'var(--epods--color-black)',
		':hover': {
			cursor: 'var(--epods--property-pointer)',
			color: 'var(--epods--color-black)',
			textDecoration: 'none',
		},
	},
};

export const itemContainer = (collapsed: boolean): StyleObject => {
  return collapsed
    ? { flex: '1', minWidth: '0', display: 'flex', alignItems: 'center', position: 'relative' }
    : {};
}

export const labelLinkSidebar = (labelEnded: boolean) => {
	return {
		whiteSpace: 'nowrap' as 'nowrap',
		lineHeight: 'var(--epods--font-size-h4)',
		paddingRight: labelEnded ? 'var(--epods--space-inset-xs)' : 0,
	} as StyleObject;
};

export const linkWrapper = (htmlFor?: string) => {
	return { display: 'inline-flex', width: htmlFor === 'sideBar' ? '100%' : 'inherit', height: '100%' } as StyleObject;
};

export const marginLeftAuto = () => {
	return { marginLeft: 'auto' } as StyleObject;
};

export const paddingRightZero = () => {
	return { paddingRight: 0 } as StyleObject;
};

export const paddingLeftZero = () => {
	return { paddingLeft: 0 } as StyleObject;
};

export const iconBeforeStyles = (htmlFor: string = '', label: string = '', iconAfter: boolean) => {
  return htmlFor === 'sideBar' && !label && iconAfter
    ? { paddingRight: 0, paddingLeft: 0, display: 'flex', alignItems: 'center' }
    : { paddingTop: 0, paddingBottom: 0, display: 'flex', alignItems: 'center' }
};

const indentFromWrapper = '-15px';
export const iconAfterContainer = ({ $itemHasLabel }: { $itemHasLabel: boolean }): StyleObject => {
  return $itemHasLabel
    // has label - icon right after the label
    ? { marginLeft: 'auto' }
    // no label - icon has fixed position
    : { position: 'absolute', right: indentFromWrapper, top: '50%', transform: 'translateY(-50%)' };
}
